// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__zI2-b","horizontalLine":"IconPlus_horizontalLine__bu7Jg","verticalLine":"IconPlus_verticalLine__RJTai","lineVerticalOpen":"IconPlus_lineVerticalOpen__L-i4D"};